import { Button, Card, Modal } from "react-bootstrap";
import { ProjectFifthStage } from "../../models/project-fifth-stage";
import * as ProjectFifthStageApi from "../../network/project-fifth-stages-api";
import styles from "../../styles/ChangeStageDialog.module.css";

interface FifthStageDialogProps {
    stage: ProjectFifthStage,
    onDismiss: () => void,
}

const FifthStageDialog = ({stage, onDismiss}: FifthStageDialogProps) => {
    const downloadFile = () => {
        ProjectFifthStageApi.fetchProjectFifthStageFile({projectId: stage.projectId});
    }
    
    return(
        <Modal show onHide={onDismiss}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Этап 5
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Card className={`mb-3 ${styles.descriptionField}`}>
                    <Card.Header>
                        Описание
                    </Card.Header>
                    <Card.Body>
                        {stage.text}
                    </Card.Body>
                </Card>
                <Button onClick={downloadFile} className={styles.downloadFileButton}>
                    Скачать закреплённый документ
                </Button>
            </Modal.Body>
        </Modal>
    );
}

export default FifthStageDialog;